import spinner from './SpinnerSingleton';

export default function spinOnNavigateDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: spinOnNavigateDirectiveCtrl,
	};
}

class spinOnNavigateDirectiveCtrl {
	constructor($element, $rootScope) {
		'ngInject';
		$element.wasClicked = false;
		$element.on('click', () => ($element.wasClicked = true));
		$rootScope.$on('$stateChangeStart', () => {
			if ($element.wasClicked) {
				$element.addClass(spinner.className);
			}
		});
		$rootScope.$on('$stateChangeSuccess', () => {
			if ($element.wasClicked) {
				$element.removeClass(spinner.className);
				$element.wasClicked = false;
			}
		});
	}
}
